import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { siteConfig } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { name: 'Tools', href: '/tools' },
    { name: 'Privacy', href: '/privacy' },
    { name: 'Contact', href: `mailto:${siteConfig.email}`, external: true },
  ];

  return (
    <footer className="relative border-t border-white/5">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo & Tagline */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <Link to="/" className="flex items-center gap-2.5 group">
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center">
                <Sparkles className="w-4 h-4 text-white" />
              </div>
              <span className="text-lg font-bold text-white">
                Summary<span className="text-gradient-accent">GPT</span>
              </span>
            </Link>
            <p className="text-slate-500 text-sm text-center md:text-left">
              {siteConfig.tagline}
            </p>
          </div>

          {/* Navigation Links */}
          <div className="flex items-center gap-8">
            {footerLinks.map((link) => (
              link.external ? (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-sm font-medium text-slate-400 hover:text-amber-400 transition-colors duration-300"
                >
                  {link.name}
                </a>
              ) : (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-sm font-medium text-slate-400 hover:text-amber-400 transition-colors duration-300"
                >
                  {link.name}
                </Link>
              )
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="my-8 section-divider" />

        {/* Copyright */}
        <div className="text-center">
          <p className="text-sm text-slate-600">
            © {currentYear} {siteConfig.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
